export function StaleConfigBanner() {
  return (
    <div className="stale" role="alert">
      <strong>Stale config.</strong> The device hasn&apos;t received an operator update for
      longer than the freshness window. Running on safe defaults (system mode off,
      all groups closed) until the cloud heartbeat resumes.
    </div>
  );
}
